import React from 'react'
import "./Banner.css"
const Banner = () => {
    return (
        <div className="banner">
                <h1 className="tituloBanner">Distribuidora Marvar Snacks</h1>
                <p className="parrafoBanner">Distribuidora de Alimentos</p>
        </div>
    )
}

export default Banner